export default class AmbassadorsSearchEngineComponent {
    constructor() {
        this.displayCloseTo()
        this.updateCloseToRange()
        this.closeToRangeLimits()

        this.displayExpertiseArea()

        this.closeEngineModal()
        this.resetQuery()
    }

    static $searchEngineRange = $('#distance-range')
    static $rangeValue = $('.js-dynamic-value')
    static lowerLimit = AmbassadorsSearchEngineComponent.$searchEngineRange.attr('min') ?? 0
    static upperLimit = AmbassadorsSearchEngineComponent.$searchEngineRange.attr('max') ?? 100

    displayCloseTo() {
        const $searchEngineCloseTo = $('.js-ambassador-search-engine-close-to-modal')
        const $searchEngineCloseToBtn = $('.js-close-to-search-engine')
        const $validationButton = $('.js-close-to-search-engine-submit')

        $searchEngineCloseToBtn.on('click', () => {
            $searchEngineCloseTo.toggleClass('is-active')

            $('body').css({
                overflow: 'hidden',
            })
        })

        $validationButton.on('click', () => {
            $searchEngineCloseTo.toggleClass('is-active')

            $('body').css({
                overflow: 'visible',
            })
        })
    }

    displayExpertiseArea() {
        const $searchEngineExpertiseArea = $('.js-ambassador-search-engine-expertise-area-modal')
        const $searchEngineExpertiseAreaBtn = $('.js-looking-for-search-engine')
        const $validationButton = $('.js-expertise-area-search-engine-submit')

        $searchEngineExpertiseAreaBtn.on('click', () => {
            $searchEngineExpertiseArea.toggleClass('is-active')

            $('body').css({
                overflow: 'hidden',
            })
        })

        $validationButton.on('click', () => {
            $searchEngineExpertiseArea.toggleClass('is-active')

            $('body').css({
                overflow: 'visible',
            })
        })
    }

    closeEngineModal() {
        const $searchEngineCloseTo = $('.js-ambassador-search-engine-close-to-modal')
        const $searchEngineExpertiseArea = $('.js-ambassador-search-engine-expertise-area-modal')
        const $searchEngineCloseBtn = $('.js-close-btn')

        $searchEngineCloseBtn.on('click', () => {
            $searchEngineCloseTo.removeClass('is-active')
            $searchEngineExpertiseArea.removeClass('is-active')

            $('body').css({
                overflow: 'visible',
            })
        })
    }

    updateCloseToRange() {
        let value = AmbassadorsSearchEngineComponent.$searchEngineRange.val()
        let progress =
            (value - AmbassadorsSearchEngineComponent.lowerLimit) /
            ((AmbassadorsSearchEngineComponent.upperLimit -
                AmbassadorsSearchEngineComponent.lowerLimit) /
                100)

        AmbassadorsSearchEngineComponent.$rangeValue.text(value)
        AmbassadorsSearchEngineComponent.$searchEngineRange.css({
            backgroundImage: `linear-gradient(to right, #5bb684 ${progress}%, #cbcbcb ${progress}%)`,
        })

        AmbassadorsSearchEngineComponent.$searchEngineRange.on('input change', function () {
            value = $(this).val()
            progress =
                (value - AmbassadorsSearchEngineComponent.lowerLimit) /
                ((AmbassadorsSearchEngineComponent.upperLimit -
                    AmbassadorsSearchEngineComponent.lowerLimit) /
                    100)

            AmbassadorsSearchEngineComponent.$rangeValue.text(value)
            AmbassadorsSearchEngineComponent.$searchEngineRange.css({
                backgroundImage: `linear-gradient(to right, #5bb684 ${progress}%, #cbcbcb ${progress}%)`,
            })
        })
    }

    closeToRangeLimits() {
        const $lowerLimitElement = $('.js-lower-limit')
        const $upperLimitElement = $('.js-upper-limit')

        $lowerLimitElement.text(`${AmbassadorsSearchEngineComponent.lowerLimit}km`)
        $upperLimitElement.text(`${AmbassadorsSearchEngineComponent.upperLimit}km`)
    }

    resetQuery() {
        const $resetButton = $('.js-ambassador-search-engine-reset')

        $resetButton.on('click', () => {
            // Obtenir l'URL actuelle
            const url = window.location.href

            // Supprimer les paramètres GET
            const parsedURL = new URL(url)
            parsedURL.search = ''

            // Rediriger vers la nouvelle URL
            window.location.href = parsedURL.toString()
        })
    }
}
